import { Component } from "react";

import Button from "@material-ui/core/Button";

export default class PayoutTableButtons extends Component {
  putOnHold = () => {
    let selected = this.props.getSelected();
    this.repeatForAll(selected, this.props.moveToReview);
  };

  autoReview = () => {
    let selected = this.props.getSelected();
    this.repeatForAll(selected, this.props.autoReview);
  };

  repeatForAll = (list, func) => {
    if (list.length > 0) {
      setTimeout(() => {
        let object = list.pop();
        func(object.Id);

        this.repeatForAll(list, func);
      }, 100);
    }
  };

  render() {
    let style = { marginRight: "10px" };
    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={this.putOnHold}
          style={style}
        >
          Put On Hold
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.autoReview}
          style={style}
        >
          Auto Review
        </Button>
      </div>
    );
  }
}
